module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Hard-drive-f3b31d5029e951573bde33ab097a0797.svg";